import {
  SEND_BROADCAST,
  SEND_BROADCAST_SUCCESS,
  SEND_BROADCAST_ERROR,
  RESET_BROADCAST,
} from './constants';

const initialState = {
  sending: false,
  result: null,
  err: null,
};

export default function broadcast(state = initialState, action) {
  switch (action.type) {
    case SEND_BROADCAST:
      return { ...state, sending: true, result: null, err: null };
    case SEND_BROADCAST_SUCCESS:
      return { ...state, sending: false, result: action.payload, err: null };
    case SEND_BROADCAST_ERROR:
      return { ...state, sending: false, err: action.err };
    case RESET_BROADCAST:
      return initialState;
    default:
      return state;
  }
}
